import React, { useEffect, useState } from 'react';
import { Column, Row } from 'react-foundation';
import LoadingSpinner from '../../../../../assets/images/loading-spinner-white.svg';
import * as api from '../../../../api/opportunitiesAPI';
import OpportunityButton from './OpportunityButton';
import SocialMediaInfluencerOpportunity from '../../../../../assets/images/social-media-influencer-opportunity.png';
import { DEFAULT_PDF_IMG } from '../../../utils/contants';
import SendShareCampaign from '../../shared/SendShareCampaign';
import { getAssetTypeFromURL } from '../../../utils';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { getDateRange } from '../../dashboard/cards/OpportunityCard';
import { formatCloudinaryThumbnailURLToBeFullSize } from '../../../../api/cloudinaryAPI';

const ShowOpportunity = ({
	orgID,
	oppID,
	isOwner,
	isSignedIn,
	isSubscribed,
}) => {
	const opportunityTemplate = {
		name: '',
		timeframe_start_on: '',
		timeframe_end_on: '',
		frequency: '',
		description: '',
		key_benefits: '',
		primary_age_group: '',
		secondary_age_group: '',
		gender: '',
		household_income: '',
		expected_audience: 0,
		expected_impressions: 0,
		reply_date: '',
		submission_date: '',
		suggested_bid: 0,
		header_media: '',
		body_media_1: '',
		body_media_2: '',
		sponsorship_deck: '',
		published: false,
		property_info_id: 0,
		opportunity_types: [],
		opportunity_locations: [],
		opportunity_hashtags: [],
		assets: [null, null, null, null],
	};

	const interestReplyTemplate = {
		first_name: '',
		last_name: '',
		company_name: '',
		phone_number: '',
		email: '',
		comment: '',
		opportunity_id: '',
	};

	const [opportunityData, setOpportunityData] = useState(opportunityTemplate);
	const [interestReply, setInterestReply] = useState(interestReplyTemplate);
	const emptyFieldMessage = 'Field cannot be left empty!';
	const [isLoading, setIsLoading] = useState(false);
	const [showSendShareCampaign, setShowSendShareCampaign] = useState(false);
	const { width } = useWindowDimensions();

	useEffect(() => {
		const fetchOpportunityData = async () => {
			try {
				const response = await api.getOpportunity(oppID);
				if (!response.data.assets) {
					response.data.assets = [null, null, null, null];
				}
				setOpportunityData(response.data);
			} catch (error) {
				console.error(error);
			}
		};
		fetchOpportunityData();
	}, []);

	const generateFormattedStringFromArray = (array) => {
		let returnString = '';
		array.map((object, index) => {
			if (array === opportunityData.opportunity_locations) {
				returnString = returnString.concat(object.location, ' | ');
			} else if (array === opportunityData.opportunity_types) {
				returnString = returnString.concat(object.name, ', ');
			} else if (array === opportunityData.opportunity_hashtags) {
				returnString = returnString.concat(object.name, ', ');
			}
		});

		// If we don't have an empty string, then remove the final delimiter ie. " | "
		if (returnString.length !== '') {
			let delimiterLength = 2;
			if (array === opportunityData.opportunity_locations) {
				delimiterLength = 3;
			}
			returnString = returnString.substring(
				0,
				returnString.length - delimiterLength
			);
		}

		return returnString;
	};

	const getSponsorshipDeck = () => {
		if (isSignedIn) {
			window
				.open(findAsset('sponsorship_deck').secure_url, '_blank')
				.focus();
		} else {
			window.open('/users/sign_in', '_self').focus();
		}
	};

	const handleChange = (event) => {
		interestReply[event.target.name] = event.target.value;
		setInterestReply(interestReply);

		if (event.target.name === 'first_name') {
			if (event.target.value === '') {
				document.getElementById(
					'first-name-empty-label'
				).style.display = 'inline-block';
			} else {
				document.getElementById(
					'first-name-empty-label'
				).style.display = 'none';
			}
		}

		if (event.target.name === 'last_name') {
			if (event.target.value === '') {
				document.getElementById('last-name-empty-label').style.display =
					'inline-block';
			} else {
				document.getElementById('last-name-empty-label').style.display =
					'none';
			}
		}

		if (event.target.name === 'company_name') {
			if (event.target.value === '') {
				document.getElementById(
					'company-name-empty-label'
				).style.display = 'inline-block';
			} else {
				document.getElementById(
					'company-name-empty-label'
				).style.display = 'none';
			}
		}

		if (event.target.name === 'phone_number') {
			if (event.target.value === '') {
				document.getElementById(
					'phone-number-empty-label'
				).style.display = 'inline-block';
			} else {
				document.getElementById(
					'phone-number-empty-label'
				).style.display = 'none';
			}
		}

		if (event.target.name === 'email') {
			if (event.target.value === '') {
				document.getElementById('email-empty-label').style.display =
					'inline-block';
			} else {
				document.getElementById('email-empty-label').style.display =
					'none';
			}
		}

		if (event.target.name === 'comment') {
			if (event.target.value === '') {
				document.getElementById('comment-empty-label').style.display =
					'inline-block';
			} else {
				document.getElementById('comment-empty-label').style.display =
					'none';
			}
		}
	};

	const handleSubmit = async () => {
		let allRequiredFieldsFilled = true;

		if (interestReply.first_name === '') {
			allRequiredFieldsFilled = false;
			document.getElementById('first-name-empty-label').style.display =
				'inline-block';
		} else {
			document.getElementById('first-name-empty-label').style.display =
				'none';
		}

		if (interestReply.last_name === '') {
			allRequiredFieldsFilled = false;
			document.getElementById('last-name-empty-label').style.display =
				'inline-block';
		} else {
			document.getElementById('last-name-empty-label').style.display =
				'none';
		}

		if (interestReply.company_name === '') {
			allRequiredFieldsFilled = false;
			document.getElementById('company-name-empty-label').style.display =
				'inline-block';
		} else {
			document.getElementById('company-name-empty-label').style.display =
				'none';
		}

		if (interestReply.phone_number === '') {
			allRequiredFieldsFilled = false;
			document.getElementById('phone-number-empty-label').style.display =
				'inline-block';
		} else {
			document.getElementById('phone-number-empty-label').style.display =
				'none';
		}

		if (interestReply.email === '') {
			allRequiredFieldsFilled = false;
			document.getElementById('email-empty-label').style.display =
				'inline-block';
		} else {
			document.getElementById('email-empty-label').style.display = 'none';
		}

		if (interestReply.comment === '') {
			allRequiredFieldsFilled = false;
			document.getElementById('comment-empty-label').style.display =
				'inline-block';
		} else {
			document.getElementById('comment-empty-label').style.display =
				'none';
		}

		if (allRequiredFieldsFilled) {
			try {
				setIsLoading(true);
				interestReply['opportunity_id'] = oppID;
				setInterestReply(interestReply);
				await api.postOpportunityReply(oppID, interestReply);
				location.assign(`/organizations/${orgID}`);
			} catch (error) {
				console.error(error);
			}
		}
	};

	const handleEdit = () => {
		location.assign(
			`/organizations/${orgID}/property_info/opportunities/${oppID}/edit`
		);
	};

	const handleOpeningLink = (link) => {
		if (link.startsWith('http') || link.startsWith('https')) {
			window.open(link, '_blank');
		} else {
			window.open('https://' + link, '_blank');
		}
	};

	/**
	 * Handles deleting of an opportunity
	 */
	const handleDelete = async () => {
		try {
			await api.deleteOpportunity(oppID);
			location.assign(`/organizations/${orgID}`);
		} catch (error) {
			console.error(error);
		}
	};

	/**
	 * Convert date strings from YYYY/MM/DD to 'MMM DD, YYYY'
	 * @param timeString the time string that will be altered
	 * @return {{String}} returns the formatted date string
	 */

	const convertDateToLongDate = (timeString) => {
		let date = new Date(timeString);
		let month = date.toLocaleString('default', { month: 'short' });
		let day = date.getDate() + 1; // JS is just the gd worst
		return month + ' ' + day + ', ' + date.getFullYear();
	};

	// const createDateString = (opportunityData) => {
	// 	let dateStr = convertDateToLongDate(opportunityData.timeframe_start_on);
	// 	if (opportunityData.timeframe_end_on) {
	// 		dateStr +=
	// 			' - ' + convertDateToLongDate(opportunityData.timeframe_end_on);
	// 	}
	// 	return dateStr;
	// };

	const findAsset = (assetEtag) => {
		for (const asset of opportunityData.assets) {
			if (!asset) continue;
			if (asset.etag === assetEtag) {
				return asset;
			}
		}
		return null;
	};

	const getEmbedLinkForAsset = (asset) => {
		let url = asset.url;
		let regExp =
			/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		let match = url.match(regExp);

		if (match && match[2].length === 11) {
			return 'https://www.youtube.com/embed/' + match[2];
		}
	};

	const showShareCampaignPopup = () => {
		setShowSendShareCampaign(true);
	};

	// Components
	const SafeRenderAsset = ({ asset, etag }) => {
		const assetType = getAssetTypeFromURL(asset?.url);
		let mobileViewClassName = 'display-only-on-mobile';

		if (width >= 900) {
			mobileViewClassName = '';
		}

		// if (assetType === 'default') {
		// 	return (
		// 		<a
		// 			className={`right-image ${mobileViewClassName}`}
		// 			href={asset?.url}
		// 			target="_blank"
		// 		>
		// 			<img
		// 				className={`right-image ${mobileViewClassName}`}
		// 				src={DEFAULT_IMG}
		// 			/>
		// 			;
		// 		</a>
		// 	);
		// }

		if (assetType === 'pdf') {
			return (
				<div
					className="sponsorship_deck card-thumbnail"
					style={{
						backgroundImage: `url(${formatCloudinaryThumbnailURLToBeFullSize(
							asset?.thumbnail_url
						)})`,
						backgroundSize: 'cover',
					}}
				>
					<a
						className="secondary-button sponsorship-button"
						href={asset?.url}
					>
						<p className="deck-button">View PDF</p>
					</a>
				</div>
			);
		}

		if (assetType === 'image') {
			return (
				<div className="card-thumbnail">
					<img className="asset-image" src={asset?.url} />
				</div>
			);
		}

		if (
			assetType === 'video' ||
			['mov', 'mp4', 'avi', 'webm', 'wmv'].includes(asset?.format)
		) {
			return (
				<div>
					<video controls className="asset-video card-thumbnail">
						<source src={findAsset(etag)?.url} />
					</video>
				</div>
			);
		}

		if (assetType === 'video-object') {
			return (
				<div>
					<object
						className="asset-video card-thumbnail"
						data={getEmbedLinkForAsset(findAsset(etag))}
						width="100%"
					/>
				</div>
			);
		}

		return null;
	};

	// const ImagesColumn = () => {
	// 	if (
	// 		!opportunityData ||
	// 		!opportunityData?.assets ||
	// 		opportunityData?.assets.includes(null)
	// 	) {
	// 		return null;
	// 	}
	// 	const bodyMediaOne = findAsset('body_media_1');
	// 	const bodyMediaTwo = findAsset('body_media_2');

	// 	return (
	// 		<div className="image-column">
	// 			<SafeRenderAsset asset={bodyMediaOne} />
	// 			<SafeRenderAsset asset={bodyMediaTwo} />

	// 		</div>
	// 	);
	// };

	const goBack = () => {
		location.assign('/');
	};

	const SponsorshipDeck = () => {
		return (
			findAsset('sponsorship_deck') && (
				<div
					className="card-thumbnail sponsorship_deck"
					style={{
						backgroundImage: `url(${formatCloudinaryThumbnailURLToBeFullSize(
							findAsset('sponsorship_deck').thumbnail_url
						)})`,
						backgroundSize: 'cover',
					}}
				>
					<div
						className="secondary-button sponsorship-button"
						onClick={getSponsorshipDeck}
					>
						<p className="deck-button">View sponsorship deck</p>
					</div>
				</div>
			)
		);
	};

	const extraStyledTopButtonContainer = () => {
		if (window.innerWidth <= 600 && !isSignedIn) {
			return {
				marginBottom: '35px',
			};
		}
	};

	return (
		<div className="display-area">
			<SendShareCampaign
				opportunityData={opportunityData}
				orgID={orgID}
				shouldShow={showSendShareCampaign}
				setShouldShow={setShowSendShareCampaign}
				isOwner={isOwner}
				isSubscribed={isSubscribed}
			/>
			<Row>
				<Column small={12}>
					<div className="back-link" onClick={() => goBack()}>
						<i className="fas fa-chevron-left" />
						<p>Return</p>
					</div>
					<div
						className="top-button-container"
						style={extraStyledTopButtonContainer()}
					>
						{isOwner && (
							<div>
								<div
									className="edit-button"
									onClick={handleEdit}
								>
									<p>
										Edit Campaign
										<i className="fas fa-edit cursor-pointer" />
									</p>
								</div>

								<OpportunityButton
									text="Delete Campaign"
									className="delete-button float-left"
									handleSubmit={handleDelete}
									isBackLink={false}
									leftButtonText="Cancel"
									rightButtonText="Delete"
									headerText="You are about to delete this opportunity."
								/>
							</div>
						)}
						<div>
							{isOwner && (
								<div
									className="primary-button"
									id="send-share-button"
									onClick={() => showShareCampaignPopup()}
								>
									<p>Share this campaign</p>
								</div>
							)}
							<div
								className="primary-button"
								id="send-share-button"
								onClick={() => {
									location.assign(`/organizations/${orgID}`);
								}}
							>
								<p>About this company</p>
							</div>
						</div>
					</div>

					<div className="header">
						{findAsset('header_media') ? (
							<img
								className="header-image"
								src={
									findAsset('header_media')?.version ===
									'upload'
										? findAsset('header_media').secure_url
										: ''
								}
								alt="header_image"
							/>
						) : (
							opportunityData.name ===
								'Social Media Influencer Sponsorship' && (
								<img
									className="header-image"
									src={SocialMediaInfluencerOpportunity}
									alt="header_image"
								/>
							)
						)}
						<h1>{opportunityData.name}</h1>
						{opportunityData.opportunity_locations.length === 1 ? (
							<div className="display-contents">
								{/* <h6>{createDateString(opportunityData)}</h6> */}
								{/* <h6>{getDateRange(opportunityData.timeframe_start_on, opportunityData.timeframe_end_on)}</h6> */}

								<h6>{opportunityData.timeframe_start_on}</h6>
								<h6 id="location-string">
									{generateFormattedStringFromArray(
										opportunityData.opportunity_locations
									)}
								</h6>
							</div>
						) : (
							<h6 id="push-down-on-mobile">
								{/* {createDateString(opportunityData)} */}
								{getDateRange(
									opportunityData.timeframe_start_on,
									opportunityData.timeframe_end_on
								)}
							</h6>
						)}
					</div>
				</Column>
			</Row>

			<Column small={12}>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						flexWrap: 'wrap',
					}}
				>
					<div className="opportunity-details-body-wrapper">
						{opportunityData.opportunity_locations.length >= 2 && (
							<div>
								<h5 className="header-font">
									Campaign location(s)
								</h5>
								{opportunityData.opportunity_locations.map(
									(location) => {
										return (
											<li
												className="location-list-li"
												key={location.id}
											>
												<ul
													className="body-font list-bullets"
													key={location.id}
												>
													{location.location}
												</ul>
											</li>
										);
									}
								)}
							</div>
						)}
						<div className="textarea-div">
							<h5 className="header-font top-10px-margin">
								{' '}
								Campaign{' '}
							</h5>
							<div className="inner-wrapper">
								<p className="body-font">
									{opportunityData.description}
								</p>
							</div>
						</div>

						{opportunityData.key_benefits && (
							<div className="textarea-div">
								<h5 className="header-font"> Key benefits </h5>
								<div className="inner-wrapper">
									<p className="body-font">
										{opportunityData.key_benefits}
									</p>
								</div>
							</div>
						)}
						<div>
							{(opportunityData.primary_age_group ||
								opportunityData.secondary_age_group ||
								opportunityData.gender ||
								opportunityData.household_income ||
								opportunityData.expected_audience ||
								opportunityData.expected_impressions ||
								opportunityData.opportunity_types.length !==
									0 ||
								opportunityData.opportunity_hashtags.length !==
									0 ||
								opportunityData.reply_date ||
								opportunityData.submission_date ||
								opportunityData.suggested_bid ||
								findAsset('sponsorship_deck')) && (
								<h5 className="header-font"> At a glance </h5>
							)}

							{opportunityData.primary_age_group && (
								<label className="body-font at-a-glance-label">
									<strong>Primary age of attendees:</strong>{' '}
									{opportunityData.primary_age_group}
								</label>
							)}

							{opportunityData.secondary_age_group && (
								<label className="body-font at-a-glance-label">
									<strong>Secondary age of attendees:</strong>{' '}
									{opportunityData.secondary_age_group}
								</label>
							)}

							{opportunityData.gender && (
								<label className="body-font at-a-glance-label">
									<strong>
										Primary gender of attendees:
									</strong>{' '}
									{opportunityData.gender}
								</label>
							)}

							{opportunityData.household_income && (
								<label className="body-font at-a-glance-label">
									<strong>
										Avg annual household income:
									</strong>{' '}
									{opportunityData.household_income}
								</label>
							)}

							{opportunityData.expected_audience && (
								<label className="body-font at-a-glance-label">
									<strong>Audience reach:</strong>{' '}
									{opportunityData.expected_audience}
								</label>
							)}

							{opportunityData.expected_impressions && (
								<label className="body-font at-a-glance-label">
									<strong>Total expected impressions:</strong>{' '}
									{opportunityData.expected_impressions}
								</label>
							)}

							{opportunityData.opportunity_hashtags.length !==
								0 && (
								<label className="body-font at-a-glance-label">
									<strong>Hashtags:</strong>{' '}
									{generateFormattedStringFromArray(
										opportunityData.opportunity_hashtags
									)}
								</label>
							)}

							{opportunityData.reply_date && (
								<label className="body-font at-a-glance-label">
									<strong>Reply with interest by:</strong>{' '}
									{opportunityData.reply_date}
								</label>
							)}

							{opportunityData.submission_date && (
								<label className="body-font at-a-glance-label">
									<strong>Submit proposal by:</strong>{' '}
									{opportunityData.submission_date}
								</label>
							)}

							{opportunityData.suggested_bid && (
								<label className="body-font at-a-glance-label">
									<strong>Suggested bid:</strong> $
									{opportunityData.suggested_bid}
								</label>
							)}

							{opportunityData.opportunity_types.length !== 0 && (
								<label
									className="body-font at-a-glance-label"
									id="sponsorable-opportunities-label"
								>
									<strong>
										Supplier and sponsor opportunities
										available:
									</strong>
									<div
										id="opportunities-check-box"
										className="check_boxes row"
									>
										<div className="button-group">
											{opportunityData.opportunity_types.map(
												(interestObject) => {
													return (
														<div
															className="tag-button"
															id={
																interestObject.id
															}
															key={
																interestObject.name
															}
														>
															<label>
																<div
																	id={
																		'sponsorable-opportunity-' +
																		interestObject.id
																	}
																>
																	<p className="body-font">
																		{
																			interestObject.name
																		}
																	</p>
																</div>
															</label>
														</div>
													);
												}
											)}
										</div>
									</div>
								</label>
							)}
						</div>
					</div>
					<div className="assets-wrapper">
						<SafeRenderAsset
							asset={findAsset('body_media_1')}
							etag={'body_media_1'}
						/>
						<SafeRenderAsset
							asset={findAsset('body_media_2')}
							etag={'body_media_2'}
						/>
						<SponsorshipDeck />
					</div>
				</div>
			</Column>
			{/* </Row> */}

			{!isOwner && (
				<div>
					{!isSignedIn ? (
						<h5 className="header-font grey-font-colour top-40px-margin">
							{' '}
							<a href="/users/sign_up">
								Create an account
							</a> and <a href="/users/sign_in">log in</a> to
							reply with interest{' '}
						</h5>
					) : (
						<div>
							<Row>
								<Column medium={6} small={12}>
									<h5 className="header-font grey-font-colour top-40px-margin">
										{' '}
										Reply with interest{' '}
									</h5>
								</Column>
							</Row>
							<Row>
								<Column medium={6} small={12}>
									<label className="upper-margin header-font">
										First Name *
									</label>
									<input
										type="text"
										className="input-field body-font-important"
										name="first_name"
										onChange={handleChange}
										disabled={isSignedIn ? '' : 'disabled'}
									/>
									<label
										className="empty-field-label"
										id="first-name-empty-label"
									>
										{emptyFieldMessage}
									</label>
								</Column>
								<Column medium={6} small={12}>
									<label className="upper-margin header-font">
										Last Name *
									</label>
									<input
										type="text"
										className="input-field body-font-important"
										id="last-name"
										name="last_name"
										onChange={handleChange}
										disabled={isSignedIn ? '' : 'disabled'}
									/>
									<label
										className="empty-field-label"
										id="last-name-empty-label"
									>
										{emptyFieldMessage}
									</label>
								</Column>
							</Row>

							<Row>
								<Column medium={6} small={12}>
									<label className="upper-margin header-font">
										Company name *
									</label>
									<input
										type="text"
										className="input-field body-font-important"
										name="company_name"
										onChange={handleChange}
										disabled={isSignedIn ? '' : 'disabled'}
									/>
									<label
										className="empty-field-label"
										id="company-name-empty-label"
									>
										{emptyFieldMessage}
									</label>
								</Column>
								<Column medium={6} small={12}>
									<label className="upper-margin header-font">
										Phone number *
									</label>
									<input
										type="tel"
										className="input-field body-font-important"
										name="phone_number"
										onChange={handleChange}
										disabled={isSignedIn ? '' : 'disabled'}
									/>
									<label
										className="empty-field-label"
										id="phone-number-empty-label"
									>
										{emptyFieldMessage}
									</label>
								</Column>
							</Row>

							<Row>
								<Column medium={6} small={12}>
									<label className="upper-margin header-font">
										Email *
									</label>
									<input
										type="email"
										className="input-field body-font-important"
										name="email"
										onChange={handleChange}
										disabled={isSignedIn ? '' : 'disabled'}
									/>
									<label
										className="empty-field-label"
										id="email-empty-label"
									>
										{emptyFieldMessage}
									</label>
								</Column>
							</Row>

							<Row>
								<Column small={12}>
									<label className="upper-margin header-font">
										Message *
									</label>
									<textarea
										className="text-area body-font-important"
										name="comment"
										onChange={handleChange}
										disabled={isSignedIn ? '' : 'disabled'}
									/>
									<label
										className="empty-field-label"
										id="comment-empty-label"
									>
										{emptyFieldMessage}
									</label>
								</Column>
							</Row>
						</div>
					)}
				</div>
			)}

			<Row>
				<Column small={12}>
					<div className="bottom-30px-margin" />
					<div className="clearfix">
						<div>
							{!isOwner && isSignedIn && (
								<div
									className="secondary-button float-right"
									id="submit-button"
									onClick={handleSubmit}
								>
									{isLoading ? (
										<img
											id="submit-loading-spinner"
											src={LoadingSpinner}
											alt="Loading spinner"
										/>
									) : (
										<p>Submit</p>
									)}
								</div>
							)}
						</div>
					</div>
				</Column>
			</Row>
		</div>
	);
};

export default ShowOpportunity;
